<template>
  <Container type="card-full" >
    <div class="header" v-if="$route.params.innerbtn">
      <!-- <vxe-button class="vxe-btn" @click="gopbrcenter">竞价</vxe-button>
      <vxe-button class="vxe-btn" @click="goOnlineTB">投标</vxe-button> -->
      <vxe-button :loading="btnLoading" type="primary" class="vxe-btn" v-for="(btn) in this.$route.params.innerbtn" @click="btnClick(btn.btncode)"
                  :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}
      </vxe-button>
    </div>
    <div class="split-line"></div>
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value">{{project.projectcode}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">平台编号</div>
              <div class="view-value">{{project.projectno}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">所在地区</div>
              <div class="view-value">{{projectAreaNmae}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购人</div>
              <div class="view-value">{{project.pcomfullname}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-value">{{project.pusername}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系方式</div>
              <div class="view-value">{{project.projectptel}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content" style="width:611px;">{{project.projectname}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">品目类型</div>
              <div class="view-value">{{project.pmname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">交易方式</div>
              <div class="view-value">{{project.prsflgdesc}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">评审方法</div>
              <div class="view-value">{{project.projectdoneflgdesc}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">价格分依据</div>
              <div class="view-value">{{project.projectpricecomputebasisdesc}}</div>
            </div>
            <div class="view-field" v-if="project.projectaveragepriceshift">
              <div class="view-label">平均价浮动率</div>
              <div class="view-value">{{project.projectaveragepriceshift}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field" v-if="project.showprojectysflg">
              <div class="view-label">{{limitamtNmae}}</div>
              <div class="view-value">
                <span v-if="project.projectlimitamt">
                  ￥{{project.projectlimitamt | qfwVal}}元
                （<amount :money="String(project.projectlimitamt)" />）
                </span>
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">预算公开</div>
              <div class="view-value">{{project.projectysflg?'公开':'不公开'}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">报价方式</div>
              <div class="view-value">{{project.projecthsflg?'含税':'不含税'}}/{{projectQuotationmodeflg}}</div>
            </div>
          </div>
          <div class="view-row" v-if="+project.projecttype === 1">
            <div class="view-field">
              <div class="view-label">代理机构</div>
              <div class="view-value">{{project.acomfullname}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-value">{{project.ausername}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系方式</div>
              <div class="view-value">{{project.projectatel}}</div>
            </div>
          </div>
          <div class="view-row" v-if="+this.$store.getters.loginUser.comtype === 1 || +this.$store.getters.loginUser.comtype === 2">
            <div class="view-field">
              <div class="view-label">采购协议</div>
              <div class="view-value" style="width:611px">{{ptcInfo.ptccode}}&nbsp;&nbsp;/&nbsp;&nbsp;{{ptcInfo.ptcname}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">业务员</div>
              <div class="view-value">{{ptcInfo.cjdptname}}&nbsp;&nbsp;/&nbsp;&nbsp;{{ptcInfo.ptccreatename}}</div>
            </div>
          </div>
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名方式</div>
              <div class="view-value">{{+project.projectisinvite === 1?'邀请':'公开'}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">报名审核</div>
              <div class="view-value">{{+project.prsbmneedconfirm === 1?'需要':'不需要'}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">报名下限</div>
              <div class="view-value" v-if="project.prssupplynums > 0">{{project.prssupplynums}}</div>
              <div class="view-value" v-else>不受限</div>
            </div>
            <!-- <div class="view-field">
              <div class="view-label">项目初审</div>
              <div class="view-value">{{+project.projectisqcheck === 1 ? '需要' : '不需要'}}</div>
            </div> -->
          </div>
          <!-- <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购报告</div>
              <div class="view-value">{{+project.projectjjreportflg === 1 ? '需要' : '不需要'}}</div>
            </div>
          </div> -->
          <!-- <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名下限</div>
              <div class="view-value" v-if="project.prssupplynums > 0">{{project.prssupplynums}}</div>
              <div class="view-value" v-else>不受限</div>
            </div>
          </div> -->
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名费</div>
              <div class="view-value">
                <span  v-if="project.projectbmamt">
                  ￥{{project.projectbmamt | qfwVal}}元
                （<amount :money="String(project.projectbmamt)"/>）
                </span>
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">缴费方式</div>
              <div class="view-value">
                <span>{{+project.projectbmpayway === 1?'线上支付':(+project.projectbmpayway === 2 ? '线下支付':+project.projectbmpayway === 3?'线上/线下支付':'')}}</span>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">保证金</div>
              <div class="view-value">
                <span v-if="project.projectbzjamt">
                  ￥{{project.projectbzjamt | qfwVal}}元
                （<amount :money="String(project.projectbzjamt)"/>）
                </span>
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">缴费方式</div>
              <div class="view-value">
                <span>{{+project.projectbzjpayway === 1?'线上支付':(+project.projectbzjpayway === 2 ? '线下支付':+project.projectbzjpayway === 3?'线上/线下支付':'')}}</span>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名开始</div>
              <div class="view-value">{{project.prsbmbegtime | longDate}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">报名截止</div>
              <div class="view-value">{{project.prsbmendtime | longDate}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">{{`${prsflgName}开始`}}</div>
              <div class="view-value">{{project.prsbjbegtime | longDate}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">{{`${prsflgName}截止`}}</div>
              <div class="view-value">{{project.prsbjendtime | longDate}}</div>
            </div>
          </div>
          <div class="view-row"  v-if="+project.prsflg === 1 || +project.prsflg === 3 || +project.prsflg === 6">
            <div class="view-field">
              <div class="view-label">报价轮次</div>
              <div class="view-value">{{project.prsbjtimes}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">轮次底价</div>
              <div class="view-value">{{+project.prsisopen === 1 ? '不公开':'公开'}}</div>
            </div>
          </div>
          <div class="view-row"  v-if="+project.prsflg === 4 || +project.prsflg === 5">
            <div class="view-field">
              <div class="view-label">梯度金额</div>
              <div class="view-value">￥{{project.projectgradientamt | qfwVal}}元 （<amount :money="String(project.projectgradientamt)" />）</div>
            </div>
            <div class="view-field">
              <div class="view-label">自动结束时长</div>
              <div class="view-value">{{project.prsnmin}}分钟</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field"  v-if="+project.prsflg === 1 || +project.prsflg === 3">
              <div class="view-label">竞价方案</div>
              <div class="view-value">{{+project.projectjjfile === 1 ? '需要':'不需要'}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">项目初审</div>
              <div class="view-value">{{+project.projectisqcheck === 1 ? '需要' : '不需要'}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">{{prsflgName + '报告'}}</div>
              <div class="view-value">{{+project.projectjjreportflg === 1 ? '需要' : '不需要'}}</div>
            </div>
          </div>
          <div class="view-row" v-if="$store.getters.loginUser.comtype=='1'">
            <div class="view-field">
              <div class="view-label">收费标准</div>
              <div class="view-value">{{project.prschangeflgdesc}}</div>
            </div>
            <div v-if="+project.prschangeflg===1" class="view-field">
              <div class="view-label">服务类型</div>
              <div class="view-value">{{project.chargefeetypedesc}}</div>
            </div>
            <div class="view-field" v-if="+project.prschangeflg===2">
              <div class="view-label">服务收费</div>
              <div class="view-value">
                {{project.prschangefee | qfwVal}}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">缴费方式</div>
              <div class="view-value">
                <span>{{+project.projectfeepayway === 1?'线上支付':(+project.projectfeepayway === 2 ? '线下支付':'线上/线下支付')}}</span>
              </div>
            </div>
          </div>
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">比选内容</div>
              <div class="view-text">
                <div v-html="project.projectdesc" style="margin-top:-12px"></div>
              </div>
            </div>
          </div>
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目备注</div>
              <div class="view-content">{{project.prsremark}}</div>
            </div>
          </div>
          <div class="view-row" v-if="+project.prsflg===2">
            <div class="view-field">
              <div class="view-label">投标模式</div>
              <div class="view-value">{{+project.projecttenderbidmode === 1 ? '线上投标':'线下投标'}}</div>
            </div>
          </div>
          <div class="view-row" v-if="+project.prsflg===2">
            <div class="view-field">
              <div class="view-label">开标模式</div>
              <div class="view-value">{{+project.projectopenbidmode === 1 ? '现场开标':'远程开标'}}</div>
            </div>
          </div>
          <div class="view-row" v-if="+project.prsflg === 2">
            <div class="view-field">
              <div class="view-label">{{`${prsflgName}地址`}}</div>
              <div class="view-content">{{project.projectbidaddr}}</div>
            </div>
          </div>
          
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">相关公告</div>
              <div class="view-link" v-if="project.noticeList && project.noticeList.length">
                <div class="view-link-item" v-for="(item, index) in project.noticeList" :key="item.noticeid">
                  <span>{{index+1}}.</span>
                  <span @click="toNotice(item)">{{item.pjnoticetitle ? '['+item.pjnoticetitle+']' :'无相关公告'}}</span>
                </div>
              </div>
              <div v-else class="view-value">无相关公告</div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :close-on-click-modal="false" @close="dialogClose" :visible.sync="dialogVisible" width="80%">
        <div v-if="dialogType===1">
          <!--结果公告-->
          <!--<project-result-notice :projectid="project.projectid"></project-result-notice>-->
        </div>
        <div v-if="dialogType===2">
          <project-other-notice :noticeid="noticeid"></project-other-notice>
        </div>
      </el-dialog>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'
  import amount from '../../views/common/amount'
  // import ProjectOtherNotice from '../bbgl/ProjectOtherNotice'views\bbgl\ProjectOtherNotice.vue
  import ProjectOtherNotice from '../../views/bbgl/ProjectOtherNotice'

  export default {
    name: 'exProjectIndex',
    mixins: [common],
    components: {vggrid,ProjectOtherNotice,amount},
    data () {
      return {
        project: {
          projectcode: '',
          projectauserid: '',
          projectacomid: '',
          projectatel: '',
          projectpuserid: '',
          projectpcomid: '',
          projectptel: ''
        },
        projectAreaNmae:'',
        pexpertInfo:{},
        appendList: [],
        appendList_zb: [],
        pmList: [],
        btnLoading: false,
        dialogVisible: false,
        dialogType: 0,
        noticeid: '',
        isshow: 0
      }
    },
    created () {
      this.getModel()
    },
    activated(){
      this.getPexertInfo()
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
      prsflgName () {
        if (this.project.prsflg == '2') {
          return '招标'
        }
        else if(this.project.prsflg == '1' || this.project.prsflg == '3') {
          return '竞价'
        }
        else if(this.project.prsflg == '6') {
          return '比选'
        }
      },
      projectQuotationmodeflg(){
        if(+this.project.projectquotationmode === 1){
          return '按金额报价'
        }
        if(+this.project.projectquotationmode === 2){
          return '按上浮率报价'
        }
        if(+this.project.projectquotationmode === 3){
          return '按下浮率报价'
        }
        if(+this.project.projectquotationmode === 4){
          return '按折扣率报价'
        }
      }
    },
    filters: {
      longDate (value) {
        return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      qfwVal (value) {
        if (!!value && +value > 0) {
          return utils.comdify(value)
        } else {
          return value
        }
      }
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
        let pmModel = this.pmList.find(v => +v.pmid === +this.project.projectpmid)
        if (pmModel) {
          this.project.projectpmiddesc = pmModel.pmname
        }
        this.project.projectysflg = +this.project.projectysflg === 1 ? true : false
        this.project.projecthsflg = +this.project.projecthsflg === 1 ? true : false
        this.project.projectneedhost = +this.project.projectneedhost === 1 ? true : false
        this.project.prsbmneedconfirm = +this.project.prsbmneedconfirm === 1 ? true : false

        if(this.project.projectid){
          this.projectAreaNmae = await this.getAreaName()
        }

        if (this.project.projectstatus == '60') {
          this.project.noticeList.push({
            noticetitle: '关于' + this.project.projectname + '的结果公告',
            noticetime: this.project.projecttime,
            wmenuname: '结果公告'
          })
        }
      },
      toNotice (item) {
        console.log(item)
        if (item.pjnoticetype) {
          this.noticeid = item.pjnoticeid
          this.dialogVisible = true
          this.dialogType = 2
        } else {
          this.dialogVisible = true
          this.dialogType = 1
        }
      },
      dialogClose () {
        this.dialogVisible = false
        this.dialogType = 0
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        this.pexpertInfo = res

        if(this.pexpertInfo.pexpertmobile == null){
            this.$message.warning('请先填写评审人资料')
            this.$router.push({name: 'pExpertIndex', params: {}})
            return
        }
      },
      async getAreaName(){
        let res = await request({
          method: 'get',
          url: 'xmgl/project/getAreaName',
          params: {cosid: this.$store.getters.expertLoginUser.cosid,projectid: this.project.projectid}
        })
        return res[0].dptareaname
      },
      async getPageList () {
        this.loading = true
      },
      async cellClick (row) {
        this.model = row
      },
      async viewProject(row) {
        this.model = row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'projectIndex'})
      }
    }
  }
</script>
